import { RouterLink, RouterModule, Router } from '@angular/router';
import { CommonModule, NgClass, NgFor } from '@angular/common';
import { Component, ElementRef, ViewChild, HostListener, OnInit, signal, OnChanges, SimpleChanges, DoCheck} from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { SliderComponent } from "./slider/slider.component";
import { AuthService } from '../../_services/auth.service';
import { BrevoService } from '../../_services/brevo.service';
import { DashboardService } from '../../_services/dashboard/dashboard.service';
import { LoaderService } from '../../_services/loader.service';
import { InrShortPipe } from '../../_pipes';

@Component({
  selector: 'app-dashboard',
  imports: [CommonModule, RouterLink, FormsModule, ReactiveFormsModule, RouterModule, SliderComponent],
  providers: [InrShortPipe],
  // imports: [CommonModule, RouterLink, FormsModule, ReactiveFormsModule, RouterModule, SliderComponent],
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
})
export class DashboardComponent implements OnInit, DoCheck {
  isMenuHidden = true; // menu default hidden
  isScrolled = false;
  isLoggedIn = signal<boolean>(false);
  isProfileOpen = false;
  userDetails: any = null;
  isBrowser = false;
  isMenuOpen = false;
  isHidden = false;

  logos: string[] = [
    'assets/img/logos/ub.png',
    'assets/img/logos/lightspeed.png',
    'assets/img/logos/ola.png',
    'assets/img/logos/bb.png',
    'assets/img/logos/linde.png',
    'assets/img/logos/infosys.png',
    'assets/img/logos/nvidia.png',
    'assets/img/logos/wipro.png',
    'assets/img/logos/bcg.png',
    'assets/img/logos/kearney.png'
  ];

  galleryImages = [
    'assets/img/gallery1.png',
    'assets/img/gallery2.png',
    'assets/img/gallery3.png',
    'assets/img/gallery4.png',
    'assets/img/gallery5.png',
  ];
  @ViewChild('slider', { static: false }) slider!: ElementRef;
  activeIndex = 3;
  items = [1, 2, 3, 4, 5];
  searchItem: any = '';
  email_subscribe: string = '';
  subscribeSuccess: boolean = false;
  subscribeError: boolean = false;
  carouselData:any = []

  expertForm!: FormGroup;
  constructor(
    private authService: AuthService,
    private brevoService: BrevoService,
    private readonly router: Router,
    private _DS: DashboardService,
    private fb: FormBuilder,
    private loader: LoaderService,
    private inrShortPipe: InrShortPipe,

  ) {}
  ngOnInit(): void {
    this.checkLoginStatus();
    this.expertForm = this.fb.group({
      name:    ['', [Validators.required]],
      email:   ['', [Validators.required, Validators.email]],
      mobile:  ['', [Validators.required, Validators.pattern(/^[0-9]{10}$/)]],
      message: ['', [Validators.required]],
    });
    if (this.isBrowser) {
      const user = localStorage.getItem('Cirlced_User');
      this.userDetails = user ? JSON.parse(user) : null;
    }
    // this.getCarouselData()
  }

  getCarouselData(){
    this._DS.getPropertyCarousel().subscribe((res:any)=>{
      this.carouselData =  res.properties

    })
  }
 
  checkLoginStatus() {
    if(this.authService.isLoggedIn()){
      this.isLoggedIn.set(this.authService.isLoggedIn());
    } else{
      this.isLoggedIn.set(false);
    }
  }

  subscribe(form: any) {
  if (form.invalid) {
    this.subscribeSuccess = false;
    this.subscribeError = false;
    return;
  }

  this.subscribeSuccess = false;
  this.subscribeError = false;

  this._DS.addSubscriber(this.email_subscribe).subscribe({
    next: () => {
      this.subscribeSuccess = true;
      this.email_subscribe = '';
      form.resetForm();
    },
    error: (err) => {
      this.subscribeError = true;
    }
  });
}

  toggleMenu() {
    this.isMenuHidden = !this.isMenuHidden;
  }



  search(item: any) {
    this.router.navigate(['/search'], {
      queryParams: { q: item }
    });
  }

   isExpertModalOpen = false;
  isFormSubmitted = false;

  openExpertModal() {
    this.isExpertModalOpen = true;
    this.isFormSubmitted = false;
  }

  closeExpertModal() {
    this.isExpertModalOpen = false;
  }
  get f() {
    return this.expertForm.controls;
  }

  submitExpertForm(): void {
    if (this.expertForm.invalid) {
      this.expertForm.markAllAsTouched();
      return;
    }
    this._DS.talkToExpertNotifiction(this.expertForm.value).subscribe({
      next: () => {
        this.expertForm.reset();
        this.isFormSubmitted = true;
      },
      error: (err) => {
        this.isFormSubmitted = false;
      }
    });
  }

  properties:any =[]
//   searchProp(){
//     this.loader.show()
//     this._DS.searchProperty(this.searchItem).subscribe({
//       next: (response:any) => {
//         if(response.data.length){
//           this.properties = response.data || [];
//           console.log('this.properties',this.properties)
//           // this.filteredProperties = [...this.properties];
//           // this.meta = response.meta || {};
//           // this.currentPage = this.meta.page;
//           // this.totalPages = this.meta.totalPages;
//         } else{
//           this.properties = []
//         }
//         this.loader.hide()
//       },
//       error: (err:any) => {
//         // this.showDeleteModal = false;
//         // this._NS.error(err.message);
//         this.loader.hide()
//       },
//     });
// }

// searchItem: string = '';
searchResults: any[] = [];
isSearching: boolean = false;
showDropdown: boolean = false;
private searchDebounce: any;

// Debounced live search as user types
onSearchChange(value: string): void {
  clearTimeout(this.searchDebounce);

  if (!value || value.trim().length < 2) {
    this.searchResults = [];
    this.showDropdown = false;
    return;
  }

  this.isSearching = true;
  this.showDropdown = true;

  this.searchDebounce = setTimeout(() => {
    this.fetchSearchResults(value.trim());
  }, 400); // 400ms debounce
}

fetchSearchResults(query: string): void {
  this._DS.searchProperty(query).subscribe({
    next: (results) => {
      this.searchResults = results.data;
      this.isSearching = false;
    },
    error: () => {
      this.searchResults = [];
      this.isSearching = false;
    }
  });
}

// Select from dropdown
selectProperty(prop: any): void {
  this.showDropdown = false;
  this.searchItem = prop.name;
  this.router.navigate(['/search'], {
    queryParams: { id: prop._id }
  });
}

// Full search page navigation
searchProp(): void {
  this.showDropdown = false;
  this.router.navigate(['/search'], {
    queryParams: { q: this.searchItem.trim() || null }
  });
}

// Close dropdown on outside click
@HostListener('document:click', ['$event'])
onDocumentClick(event: MouseEvent): void {
  const target = event.target as HTMLElement;
  if (!target.closest('.search-bar') && !target.closest('.relative')) {
    this.showDropdown = false;
  }
}




  isMobile() {
    return /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
  }
  ngDoCheck(): void {
    this.checkLoginStatus();
  }
  gotoSearch(type:any){
    this.router.navigate(['/search'], {
      queryParams: {
        propertyType:type,
      }})
    }
    getMinPrice(priceRange: any[]): string {
      const min = Math.min(...priceRange.map((p: any) => Number(p.price)));
      return this.inrShortPipe.transform(min); // format AFTER math
    }
    
    getMaxPrice(priceRange: any[]): string {
      const max = Math.max(...priceRange.map((p: any) => Number(p.price)));
      return this.inrShortPipe.transform(max); // format AFTER math
    }
    
    getBhkTypes(priceRange: any[]): string {
      return priceRange.map(p => p.bhkType).join(' · ');
      // Output: "1 BHK · 2 BHK"
    }

  @HostListener('window:scroll', [])
  onScroll() {
    const section = document.querySelector('.parallax-section') as HTMLElement;
    const image = document.querySelector('.parallax-img') as HTMLElement;

    if (!section || !image) return;

    const rect = section.getBoundingClientRect();

    const windowHeight = window.innerHeight;

    // Check if section is in viewport
    if (rect.top < windowHeight && rect.bottom > 0) {

      // Progress inside viewport (0 → 1)
      const progress = (windowHeight - rect.top) / (windowHeight + rect.height);

      // Apply controlled movement
      const translate = (progress - 0.8) * 100; // adjust strength here

      image.style.transform = `translateY(${translate}px) scale(1.1)`;
    }
  }
  navigateWithReload(path: string) {
    window.location.href = path;
  }
}
